import { useRef, useState, useEffect } from 'react';

export function useScrollReveal(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setInView(true); obs.unobserve(el); }
    }, { threshold });
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return { ref, inView };
}

export const revealStyle = (inView) => ({
  opacity: inView ? 1 : 0,
  filter: inView ? 'blur(0)' : 'blur(8px)',
  transform: inView ? 'translateY(0) scale(1)' : 'translateY(50px) scale(0.96)',
  transition: 'opacity 0.9s ease-out, transform 0.9s ease-out, filter 0.9s ease-out',
});
